import { render, staticRenderFns } from "./TableSort.vue?vue&type=template&id=690f28ba&scoped=true&"
import script from "./TableSort.vue?vue&type=script&lang=js&"
export * from "./TableSort.vue?vue&type=script&lang=js&"
import style0 from "./TableSort.vue?vue&type=style&index=0&id=690f28ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690f28ba",
  null
  
)

export default component.exports